<template>
    <div style="margin: 20px 0px">
        <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
            <template slot-scope="scope" slot="menu">
                <el-button  class="View" >详情</el-button>
                <el-button  class="View" >补充证据</el-button>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    export default {
        name: "caseClosed",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [
                    {
                        name:'张三',
                        sex:'男',
                        applicant:'2022.10.15 12:30:10',
                        condition:'已结案'
                    }, {
                        name:'李四',
                        sex:'女',
                        applicant:'2022.10.15 12:30:10',
                        condition:'已结案'
                    }
                ],
                option:{
                    searchLabelWidth:100,
                    align:'center',
                    menuAlign:'center',
                    stripe:true,
                    menuWidth: 240,//操作菜单栏的宽度
                    refreshBtn: false, //刷新按钮
                    columnBtn:false, //列动态显隐按钮
                    addBtn:false,  // 新增按钮
                    delBtn:false, // 行删除按钮
                    editBtn:false, // 行编辑按钮
                    column:[
                        {
                            label:'案件名称',
                            prop:'name',
                            search:true,
                            searchSpan:5, //输入框宽度

                        }, {
                            label:'被申请人',
                            prop:'sex',
                            search:true,
                        }, {
                            label:'提交案件时间',
                            prop:'applicant',
                            search:true,
                            type:'datetime',
                            searchRange:true,
                        }, {
                            label:'状态',
                            prop:'condition',
                        }
                    ]
                },
            };
        },
        methods:{
            changePage(num){
                console.log(num)
            }
        },
        created() {
            // console.log(this.data)
            this.data.length=this.page.pageSize
        }
    }
</script>

<style scoped>
    /deep/.avue-form__group{
        align-items: flex-end;
    }
    /deep/.avue-form__menu{
        width: 300px;
    }
    .View{
        background-color: #3b63f6;
        color: #fff;
    }
    /deep/.el-card{
        text-align: center;
    }
</style>
